import { render, staticRenderFns } from "./CreatorApplicationsPage.vue?vue&type=template&id=7b071f81"
import script from "./CreatorApplicationsPage.vue?vue&type=script&lang=ts"
export * from "./CreatorApplicationsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports